<template>
  <div id="contenedor" ref="printHomePage">
    <v-container fluid class="white lighten-5">
      <guest-view v-if="$hasAnyRole(['Guest'])" />
      <reports-view v-if="$hasAnyRole(['Reports'])" />

      <loading-bar :captured-dialog-loading="dialogLoading" />
      <div id="cards">
        <v-row v-if="!$hasAnyRole(['Guest'])">
          <v-col cols="12">
            <customer-information
              :customer="customer"
              @customerInfoloaded="customerLoaded"
            />
            <contact-desk :general-info-customer="customer" />

            <fill-rate
              :user-id="customer.KUNNR"
              option="C"
              :chnl="customer.VTWEG"
            />

            <order-delivery-time
              :customer="customer.KUNNR"
              :chnl="customer.VTWEG"
            />

            <wallet-information
              :customer="customer"
              @walletLoaded="walletLoaded"
            />
            <history-shopping
              :general-info-customer="customer"
              :wallet-information="walletInformation"
            />
            <indicators-payment :general-info-customer="customer" />
            <growth-indicators :general-info-customer="customer" />
            <growth-benefit-history :customer="customer.KUNNR" />
            <quarterly-bonus :general-info-customer="customer" />
            <total-additional-benefits :general-info-customer="customer" />
          </v-col>
          <confidentiality-notice />
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
  import ContactDesk from '@/components/ContactDesk.vue';
  import FillRate from '@/views/fill_rate/FillRate.vue';
  import WalletInformation from '@/views/wallet/WalletInformation.vue';
  import HistoryShopping from '../components/HistoryShopping.vue';
  import IndicatorsPayment from './indicators_payment/IndicatorsPayment.vue';
  import QuarterlyBonus from './quarterly_bonus/QuarterlyBonus.vue';
  import GuestView from '@/views/auth/GuestView.vue';
  import CustomerInformation from '@/views/auth/CustomerInformation.vue';
  import ReportsView from '@/views/auth/ReportsView.vue';
  import GrowthBenefitHistory from '@/views/growth_benefit_history/GrowthBenefitHistory.vue';
  import TotalAdditionalBenefits from '@/views/total_benefits/TotalAdditionalBenefits.vue';
  import GrowthIndicators from './growth_indicators/GrowthIndicators.vue';
  import LoadingBar from './shopping_cart/componets/LoadingBar.vue';
  import imagedesk from '@/assets/img/logo_sd.png';
  import { mapGetters, mapActions } from 'vuex';
  import ConfidentialityNotice from '@/components/ConfidentialityNotice.vue';
  import OrderDeliveryTime from './oder_delivery_time/OrderDeliveryTime.vue';
  import loader from '@/mixins/loader';

  export default {
    components: {
      ContactDesk,
      FillRate,
      WalletInformation,
      HistoryShopping,
      IndicatorsPayment,
      QuarterlyBonus,
      GuestView,
      CustomerInformation,
      ReportsView,
      GrowthIndicators,
      GrowthBenefitHistory,
      TotalAdditionalBenefits,
      LoadingBar,
      ConfidentialityNotice,
      OrderDeliveryTime,
    },
    mixins: [loader],
    data() {
      return {
        data: null,
        bonus: null,
        imageDesk: imagedesk,
        customer: [],
        dialogLoading: false,
        showPrint: true,
        walletInformation: [],
      };
    },
    computed: {
      currentPeriod() {
        const today = new Date();
        let firstDay = 1;
        //   let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        //   lastDay = lastDay.getDate()
        let year = today.getFullYear();
        let currentMonth = today.toLocaleString('default', { month: 'long' });
        currentMonth =
          currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1);
        return ` del (${firstDay} de ${currentMonth} ${year} al ${today.getDate()} de ${currentMonth} del ${year})`;
      },
      ...mapGetters({
        user: 'auth/user',
      }),
    },
    methods: {
      ...mapActions({
        sendToPDF: 'printer/sendToPDF',
        getBonusesCustomer: 'bonusCustomer/getBonusesCustomer',
      }),
      customerLoaded(customer) {
        this.customer = customer;
        this.sendToPDF({ active: true });

        try {
          this.getBonusesCustomer({
            customerCode: this.customer.KUNNR,
            channel: this.customer.VTWEG,
          });
        } catch (error) {
          this.$toast.error(error.message);
        }
      },
      walletLoaded(value) {
        this.walletInformation = value;
      },
    },
  };
</script>
<style scoped>
  .container-contact-card {
    width: 280px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #0000004f;
    border-radius: 20px;
  }

  .contact-card-bordered {
    border-width: 0px 0px 0px 1px;
    border-style: solid;
    border-color: #e2e2e2;
  }

  .contact-email-text {
    text-decoration: underline;
    font-size: 12px;
    letter-spacing: 0px;
    color: #ff000a;
    font-weight: bold;
    opacity: 1;
  }

  .contact-phone-text {
    text-decoration: underline;
    font-size: 12px;
    letter-spacing: 0px;
    font-weight: bold;
    color: #0f719d;
  }
</style>
